/* @flow */

import * as React from 'react';

import PropTypes from 'prop-types';

export const UIContextPropType = PropTypes.shape({
  registerAnalyticsEvent: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  onLogoClick: PropTypes.func,
  appName: PropTypes.string.isRequired,
});

type AnalyticsEventFunc = (event: string, data?: { [string]: string }) => void;

export type UIProviderContext = {
  dbui: {
    registerAnalyticsEvent: AnalyticsEventFunc,
    logo: string,
    onLogoClick?: () => void,
    appName: string,
  },
};

type UIProviderProps = {
  onAnalyticsEvent: AnalyticsEventFunc,
  children?: React.Node,
  logo: string,
  onLogoClick?: () => void,
  appName: string,
};

export default class UIProvider extends React.Component<UIProviderProps> {
  static childContextTypes = {
    dbui: UIContextPropType,
  };

  getChildContext(): UIProviderContext {
    return {
      dbui: {
        registerAnalyticsEvent: this.props.onAnalyticsEvent,
        logo: this.props.logo,
        onLogoClick: this.props.onLogoClick,
        appName: this.props.appName,
      },
    };
  }

  render() {
    return this.props.children;
  }
}
